export const portalHasAccessToEligibilityFlow = ({
  hasWriteScope,
  hasEFScope,
  ownsPaidMarketingHub
}) => hasWriteScope || hasEFScope || ownsPaidMarketingHub;
export const shouldShowEligibilityFlow = ({
  marketingContactsOnRenewal,
  hasAccessToEligibilityFlow
}) => {
  if (hasAccessToEligibilityFlow && marketingContactsOnRenewal && marketingContactsOnRenewal > 0) {
    return true;
  }
  return false;
};